import "core-js";
import "regenerator-runtime/runtime";
/*import "react-app-polyfill/ie9";*/
import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Store/";
import { OidcProvider } from "redux-oidc";
import userManager from "./Common/Utility/usermanager";
//import "semantic-ui-css/semantic.min.css";
import "./static/css/main.css";
// import 'react-redux-notify/dist/ReactReduxNotify.css';
import registerServiceWorker from "./registerServiceWorker";
const rootElement = document.getElementById("root");
const app = (
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OidcProvider>
  </Provider>
);

ReactDOM.render(app, rootElement);

registerServiceWorker();
